import React, { Component } from 'react';
import { Grid, Form, Button, Segment, Divider, Dropdown, Header } from 'semantic-ui-react';
import BreadcrumbCustom from '../../layout/BreadcrumbCustom';

class UserGroup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: 'React'
    };
  }

  render() {
    return (
      <div>
        <BreadcrumbCustom {...this.props} parent="Administrator" child={[{ name: "User Groups", url: null }]} />
        <Grid className="g-bkgd">
          <Grid.Row>
            <Grid.Column>
              <Form className="small">
                <Segment.Group>
                  <Segment>
                    <Header as="h4">Create a New Group</Header>
                    <Divider></Divider>
                    <Form.Group>
                      <Form.Field width={4} className="required">
                        <label>Group Name:</label>
                        <Form.Input placeholder='Group Name' />
                      </Form.Field>
                      <Form.Field width={2}>
                        <Button.Group className="small push-down">
                          <Button>{this.props.t("reset")}</Button>
                          <Button.Or />
                          <Button positive>{this.props.t("submit")}</Button>
                        </Button.Group>
                      </Form.Field>
                    </Form.Group>
                  </Segment>
                </Segment.Group>
                <Segment.Group>
                  <Segment>
                    <Header as="h4">Manage Group</Header>
                    <Divider></Divider>
                    <Form.Group>
                      <Form.Field width={4} className="required">
                        <label>Group Name:</label>
                        <Dropdown placeholder='Select' className="fluid" multiple search selection options={[]}></Dropdown>
                      </Form.Field>
                      <Button.Group width={2} className="small buttons push-down">
                        <Button>Delete Group</Button>
                      </Button.Group>
                    </Form.Group>
                  </Segment>
                </Segment.Group>
              </Form>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </div>
    );
  }
}
export default UserGroup;


// WEBPACK FOOTER //
// ./src/app/ui/administrations/UserGroup.js